<template>
  <div class="content-main flex">
    <BaseOrderModal
      @closeOrder="openOrder(null)"
      :orderUUID="openedOrder"
      v-model="showOrderModal"
    />
    <template>
      <BaseLeftPageSubMenu
        :menuItems="orderExportStatusOptions"
        :selectedStatus="filters.statusSystem"
        @selectedStatusFilter="updateStatusFilter"
      />
      <div class="content">
        <div class="header flex flex-row items-center gap-6">
          Orders
          <BaseOrderSearch
            :value="filters.search"
            @search="updateSearchFilter"
          />
        </div>
        <div class="table">
          <OrdersFilters
            v-model="filters"
            manualSearch
            :sellers="sellers"
            :shippingServices="shippingServicesInOrders"
            :statusAvailable="orderStatusOptions"
          />
          <table class="default-table" v-if="!loading">
            <thead>
              <tr class="table100-head">
                <th
                  v-for="headerItem in tableHeaders"
                  :key="headerItem.value"
                  @click="changeArrowDir(headerItem.value)"
                >
                  {{ headerItem.displayText }}
                  <span v-if="filters.orderCol == headerItem.value">
                    <img
                      :src="
                        require(`@/assets/icons/${arrowDirection}-arrow.svg`)
                      "
                    />
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="order in orders"
                :key="order.uuid"
                @click="openOrder(order.uuid)"
                :class="{
                  selected: selectedOrder == order.uuid,
                  'bg-warning': order.fulfillmentStatus == 0
                }"
                :title="
                  order.fulfillmentStatus == 0
                    ? 'Incomplete stock'
                    : order.orderKey
                "
              >
                <td class="orders-column">
                  {{ order.orderKey }}
                  {{
                    order.orderKey !== order.orderNumber
                      ? `(${order.orderNumber})`
                      : ""
                  }}
                </td>
                <td>
                  {{ order.orderDate }}
                </td>
                <baseTooltip
                  :text="order.products"
                  :disabled="!order.products || order.products == ''"
                >
                  <td class="products-column" style="max-width: 80px">
                    {{ order.products }}
                  </td>
                </baseTooltip>
                <td>
                  {{ order.status }}
                </td>
                <td>
                  {{ order.shippingAddressName }}
                </td>
                <td>
                  {{ order.shippingAddressState }}
                </td>
                <td>
                  {{ order.shippingAddressCountry }}
                </td>
                <td>
                  {{ order.salesman }}
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else>
            Loading...
          </div>
        </div>
        <div class="footer">
          <div class="totals">
            showing {{ filters.limitPerPage * (filters.page - 1) }} to
            {{ toQuantity() }} from {{ totalItems }} results
          </div>
          <div class="pages">
            <select
              v-model="ordersByPage"
              @change="
                (filters.limitPerPage = ordersByPage), (filters.page = 1)
              "
            >
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
            Per Page
          </div>
          <div class="pages">
            <div>
              <a
                :class="{ disabled: filters.page == 0 }"
                class="page-link"
                @click="previous()"
              >
                Previous
              </a>
            </div>
            <div>Page {{ filters.page }}</div>
            <div>
              <a
                :class="{
                  disabled: totalPages > filters.page
                }"
                class="page-link"
                @click="next()"
              >
                Next
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { getOrders, createQueryString } from "@/api/SyncSystem.js";
import OrdersFilters from "@/components/OrdersFilters.vue";
export default {
  name: "OrdersPageInfoauto",
  data() {
    return {
      showOrderModal: false,
      publicPath: process.env.VUE_APP_IMG_BASE_URL,
      tableHeaders: [
        {
          displayText: "Order Number",
          value: "orderNumber"
        },
        {
          displayText: "Order Date",
          value: "orderDate"
        },
        {
          displayText: "Products",
          value: "products"
        },
        {
          displayText: "status",
          value: "status"
        },
        {
          displayText: "Shipping Name",
          value: "shippingName"
        },
        {
          displayText: "State",
          value: "state"
        },
        {
          displayText: "Country",
          value: "country"
        },
        {
          displayText: "Marketplace",
          value: "marketplace"
        }
      ],
      orderExportStatusOptions: [
        {
          displayText: "Ready To export",
          value: "pending_to_be_sent"
        },
        {
          displayText: "Error Status",
          value: "error_sending_to_system"
        },
        {
          displayText: "Disabled export",
          value: "disabled_export"
        },
        {
          displayText: "Exported",
          value: "sent_to_system"
        },
        {
          displayText: "All status",
          value: ""
        }
      ],
      filters: {
        shippingAddressName: "",
        marketplaceId: "",
        salesman: "",
        customerEmail: "",
        customerInfoauto: {
          name: "",
          id: ""
        },
        status: "",
        shippingServiceRequested: "",
        product: "",
        statusSystem: "pending_to_be_sent",
        page: 1,
        limitPerPage: 100,
        orderCol: "orderDate",
        orderDir: "desc",
        search: ""
      },
      ordersByPage: 100,
      systemCode: "infoauto",
      orders: [],
      totalItems: 0,
      totalPages: 0,
      loading: true,
      selectedOrder: null,
      openedOrder: "",
      apiCallId: null,
      // pending
      shippingServicesInOrders: [],
      statusInOrders: []
    };
  },
  components: {
    OrdersFilters
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.loading = true;
        const query = {
          ...this.$route.query,
          search: createQueryString(this.filters)
        };
        this.$router.replace({ query }).catch(() => {});
        this.loadOrders();
        console.log("changed filters");
      }
    }
  },
  computed: {
    orderStatusOptions() {
      return this.$store.getters["general/getOrderStatusList"];
    },
    arrowDirection() {
      return this.filters.orderDir == "desc" ? "down" : "up";
    },
    sellers() {
      return this.$store.getters["general/getSellers"];
    }
  },
  mounted() {
    if (this.$route.query.search) {
      // Se arma aparte y se asigna una sola vez: el watcher de filters hace la
      // carga. Asignar campo por campo y ademas llamar a loadOrders pedia las
      // ordenes dos veces.
      const fromUrl = {};
      let searchParams = new URLSearchParams(this.$route.query.search);
      for (let p of searchParams) {
        switch (p[1]) {
          case "true":
            p[1] = true;
            break;
          case "false":
            p[1] = false;
            break;
          case "null":
            p[1] = null;
            break;
          default:
            break;
        }
        if (p[0] === "otherFilters") {
          let otherFilters = p[1].split("&");
          otherFilters.forEach(element => {
            let filter = element.split("=");
            this.filters.otherFilters[filter[0]] = decodeURIComponent(
              filter[1]
            );
            console.log(decodeURIComponent(filter[1]));
          });
        } else {
          fromUrl[p[0]] = decodeURIComponent(p[1]);
        }
      }
      this.filters = { ...this.filters, ...fromUrl };
    } else {
      this.loadOrders();
    }
    if (this.$route.query.orderOpen) {
      this.openOrder(this.$route.query.orderOpen);
    }
  },
  methods: {
    updateSearchFilter(search) {
      this.filters.page = 1;
      this.filters.search = search;
    },
    logout() {
      this.$store.dispatch("auth/logOut");
      this.$router.push("/");
    },
    updateStatusFilter(status) {
      this.filters.page = 1;
      this.filters.statusSystem = status;
    },
    async loadOrders() {
      this.apiCallId = new Date();
      let apiCallIdCurrent = this.apiCallId;

      const res = await getOrders(this.filters, this.systemCode).catch(() => {
        alert("Error getting orders");
      });

      if (apiCallIdCurrent !== this.apiCallId) {
        console.warn("new request in process");
        return;
      }

      this.orders = res.orders;
      this.totalItems = res.totalItems;
      this.totalItems = res.totalItems;
      this.totalPages = res.totalPages;
      this.loading = false;
    },
    previous() {
      if (this.filters.page > 1) {
        this.filters.page = this.filters.page - 1;
      }
    },
    next() {
      if (this.totalItems >= this.filters.limitPerPage * this.filters.page) {
        this.filters.page = this.filters.page + 1;
      }
    },
    toQuantity() {
      if (this.qtyPerPage * this.page > this.totalItems) {
        return this.orders.length;
      } else {
        return (
          this.filters.limitPerPage * (this.filters.page - 1) +
          this.orders.length
        );
      }
    },
    changeArrowDir(headerValue) {
      this.filters.page = 1;
      if (headerValue == this.filters.orderCol) {
        this.filters.orderDir =
          this.filters.orderDir == "desc" ? "asc" : "desc";
      } else {
        this.filters.orderCol = headerValue;
        this.filters.orderDir = "desc";
      }
    },
    openOrder(orderId) {
      console.log(orderId);
      this.openedOrder = orderId;
      if (orderId != null) {
        this.showOrderModal = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";

.content-main {
  .content {
    padding: 5px;
    width: 100%;
    overflow-x: auto;
    .header {
      width: 100%;
      padding: 20px 15px;
    }
    .table {
      width: 100%;
      height: calc(100% - 200px);
      overflow-x: auto;
      margin-bottom: 10px;
      .products-column {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: middle;
      }
      .orders-column {
        max-width: 200px;
        min-width: 200px;
      }
      table {
        td {
          font-size: 14px;
          white-space: nowrap;
        }
        a {
          font-size: 14px;
        }
      }
    }
    .footer {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      .pages {
        display: flex;
        flex-direction: row;
        div {
          width: 75px;
        }
        .page-link {
          color: $link-color-1;
        }
      }
    }
  }
}
</style>
